import { render, staticRenderFns } from "./order_type.vue?vue&type=template&id=2b17ae2a&"
import script from "./order_type.vue?vue&type=script&lang=ts&"
export * from "./order_type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports